<rotec-modal-v2 [title]="title" [width]="width" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <div class="location-modal-content">
      <div class="location-item">
        <div class="label">
          {{ 'Angle' | translate }}
          <rotec-icon-v2 class="required-icon" svgIcon="union" color="pink"></rotec-icon-v2>
        </div>
        <rotec-number-input-v2
          [value]="angleValue"
          [info]="'°'"
          min="0"
          max="360"
          [autofocus]="true"
          (confirmValueChange)="valid && save()"
          (valueChange)="validate($event)"
          [darkMode]="true"
        ></rotec-number-input-v2>
      </div>
      <div class="location-item">
        <div class="label">{{ 'Restricted' | translate }}</div>
        <rotec-checkbox-v2
          [status]="restrictedValue"
          (statusChange)="restrictedValue = $event"
        ></rotec-checkbox-v2>
      </div>
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="location-modal-buttons">
      <button rotec-button-primary-v2 dark (click)="cancel()">
        {{ 'Cancel' | translate }}
      </button>
      @if (showDeleteButton) {
        <button class="delete-location" rotec-button-warning dark (click)="deleteLocation()">
          {{ 'Delete' | translate }}
        </button>
      }
      <button rotec-button-active dark [disabled]="!valid" (click)="save()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
